import React from "react";
import Header from "./header";
import styled, { ThemeProvider } from "styled-components";
import breakpoint from "styled-components-breakpoint";
import SizeAware from "../components/size-aware";

import "../styles/layout.css";

export const theme = {
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  spacing: {
    xs: 15,
    sm: 30,
    md: 30,
    lg: 40,
    xl: 60
  }
};

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 250px;
  padding: 0;
  justify-content: space-around;
  flex-wrap: nowrap;
  align-items: stretch;
  overflow: auto;
  height: 100vh;
  height: -webkit-fill-available;

  .content-height {
    height: 100%;
    max-height: calc((100vh - ${props => props.headerHeight ? `${props.headerHeight}px` : `0px`}) + 2px);
  }

  .content-height-minus {
    height: 100%;
    max-height: calc((100vh - ${props => props.headerHeight ? `${props.headerHeight}px` : `0px`}) - 45px + 2px);
  }

  .content-height-min {
    height: 100%;
    min-height: calc((100vh - ${props => props.headerHeight ? `${props.headerHeight}px` : `0px`}) + 2px);
  }
`;

const StyledPanelTop = styled.div`
  flex: none;
  background-color: var(--color-white);
  border-bottom: 2px solid var(--color-black);

  ${breakpoint("xl")`
    overflow: hidden;
    height: 122px;
  `}
`;

const StyledPanelContent = styled.div`
  position: relative;
  flex: 1 1 auto;
  overflow: scroll;
  height: calc((100vh - ${props => props.headerHeight ? `${props.headerHeight}px` : `0px`}) + 18px);
`;

export const FixedImage = styled.div`
  display: none;

  ${breakpoint("md")`
    display: block;
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: calc(50% - 6px);
    border-right: 2px solid var(--color-black);
    // height: calc((100vh - ${props => props.headerHeight ? `${props.headerHeight}px` : `0px`}));
    height: calc(100vh - 124px);
    background-image: url(${props => props.fixedImageSrc});
    background-size: cover;
    background-position: 50% 50%;
  `}
`;

const Layout = ({ children, onHideNav, onShowNav, showNav, siteTitle, ...props }) => {
  // console.log(location)
  // console.log(prevLocation)
  return (
    <ThemeProvider theme={theme}>
      <>
        <LayoutPanelsComponent
          siteTitle={siteTitle}
          onHideNav={onHideNav}
          onShowNav={onShowNav}
          showNav={showNav}
          children={children}
          {...props}
        />
      </>
    </ThemeProvider>
  )
};

class LayoutPanelsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerHeight: 0
    }
  }

  onSize = size => {
    // console.log('Header has a height of', size.height);
    this.setState({
      headerHeight: size.height
    })
  }

  render() {
    return (
      <StyledPanelContainer headerHeight={this.state.headerHeight}>
        <SizeAware onSize={this.onSize}>
          <StyledPanelTop>
            <Header
              siteTitle={this.props.siteTitle}
              onHideNav={this.props.onHideNav}
              onShowNav={this.props.onShowNav}
              showNav={this.props.showNav}
            />
          </StyledPanelTop>
        </SizeAware>
        <StyledPanelContent headerHeight={this.state.headerHeight} id="scroller">
          {this.props.children}
        </StyledPanelContent>
      </StyledPanelContainer>
    );
  }
}

export default Layout;
